import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

import DropdownMenuItem from '@/layouts/AppLayoutHeader/components/DropdownMenuItem.vue'
import { translationProvider } from '@/services/translationProvider'
import { i18n, languages } from '@/services/i18n'
import SimpleIcon from '@/layouts/AppLayoutHeader/components/SimpleIcon.vue'
import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'
import { analytics } from '@/services/analyticsProvider'
import carrierUserService from '@/services/carrierUserService'
import errorsHandler from '@/services/errors-handler'


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageDropdownSelector',
  props: {
  hide: { type: Boolean, default: false },
},
  setup(__props) {



const onLanguageUpdate = async (language: string) => {
  analytics.trackEvent(ANALYTICS_EVENTS.LANGUAGE_CHANGE)
  try {
    await carrierUserService.changeLanguage(language)
  } catch (error: any) {
    error.notification = {
      message: i18n.global.t('serverError.msg'),
    }
    errorsHandler(
      error,
      '[orcas-shell - Store]: Language choice can not be sent'
    )
  }
}

const setLanguage = async (language: string) => {
  await translationProvider.set(language, {
    updated: onLanguageUpdate,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["language-dropdown", { 'language-dropdown--hide': __props.hide }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
      return (_openBlock(), _createBlock(DropdownMenuItem, {
        onClick: ($event: any) => (setLanguage(language.value)),
        key: language.value,
        class: "language-dropdown-item"
      }, {
        after: _withCtx(() => [
          (_unref(translationProvider).currentLanguage === language.value)
            ? (_openBlock(), _createBlock(SimpleIcon, {
                key: 0,
                class: "language-check-icon",
                name: "check-icon"
              }))
            : _createCommentVNode("v-if", true)
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(language.label) + " ", 1 /* TEXT */)
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}
}

})